export default arr => arr[arr.length - 1]
